import { PolarisBreakPoint } from '@/constants/enum';
import styled from 'styled-components';

export const StyledScrollUp = styled.div`
  position: fixed;
  bottom: 6rem;
  right: 2rem;
  opacity: 0;
  visibility: hidden;
  transition: opacity 500ms ease, visibility 500ms ease;
  z-index: 1000000;

  @media only screen and (max-width: ${PolarisBreakPoint.SM}) {
    /* BFS 4.1.2: ẩn hẳn trên mobile — tiện ích điều hướng, không phải nội dung.
       display:none thắng .active (chỉ chỉnh opacity/visibility) nên nút không
       hiện và không chiếm chỗ kể cả khi cuộn > 500px. */
    display: none;
    bottom: 5rem;
    right: 1.125rem;
  }

  svg {
    cursor: pointer;
  }

  &.active {
    opacity: 1;
    visibility: visible;
  }
`;
